import { QUERY_KEYS } from "@/api/constants";
import { queryClient } from "@/api/queryClient";
import type { PaginationParams } from "@/types/api";

export const entityHistoryKeys = {
  all: () => [QUERY_KEYS.entityHistory] as const,
  scope: (entityIdOrType: string) =>
    [QUERY_KEYS.entityHistory, entityIdOrType] as const,
  query: (entityIdOrType?: string, params?: PaginationParams) =>
    [QUERY_KEYS.entityHistory, entityIdOrType, params] as const,
};

export type InvalidateEntityHistoryOptions = {
  scope?: string;
};

export const invalidateEntityHistory = (
  options?: InvalidateEntityHistoryOptions
) => {
  if (options?.scope) {
    return queryClient.invalidateQueries({
      queryKey: entityHistoryKeys.scope(options.scope),
    });
  }

  return queryClient.invalidateQueries({
    queryKey: entityHistoryKeys.all(),
  });
};
